// TODO: Migrate to financeable-ui once the shared form fields move off MUI Grid.
import { Grid } from "@mui/material";
import { ConditionFieldOptions } from "@/constants";
import { TypeOfSale } from "@/store/slices/types/applicationFormSlice";
// @ts-expect-error: ignoring as it is existing js file
import generateArrayOfYears from "@/utils/generateArrayOfYears";
import { AssetManualFieldsProps } from "@/utils/interface";
import { getAssetFieldAnchorId } from "@/utils/commonFunctions";
import { ASSET_FIELD } from "./assetRequiredFields";
import FormInputField from "../CommonComponents/FormInputField";
import FormAutoCompleteField from "../CommonComponents/FormAutoCompleteField";

/**
 * Make, model, condition and year typed by hand. Used both when the broker opts out of the lookup and
 * when the asset class has no lookup behind it at all — the two used to be duplicate JSX.
 */
const AssetManualFields = ({
  assetId,
  allValues,
  handle,
  getLocalAndLenderError,
  searchVehicleLoader,
  typeOfSale,
  isDisableEdit,
}: AssetManualFieldsProps) => {
  const anchorId = (fieldName: string) => getAssetFieldAnchorId(fieldName, assetId) || undefined;

  return (
    <Grid container direction="row" style={{ margin: "15px 0 0 0" }}>
      <Grid container spacing={1}>
        <FormInputField
          id={anchorId(ASSET_FIELD.make)}
          fieldName="make"
          label="Make"
          value={allValues?.make}
          error={!!getLocalAndLenderError({ fieldName: "make" })}
          helperText={getLocalAndLenderError({ fieldName: "make" })}
          disabled={searchVehicleLoader || isDisableEdit}
          onChange={handle.onChangeField}
          onBlur={handle.blurFn}
          inputProps={{ maxLength: 50 }}
          gridProps={{ md: 3, sm: 12, xs: 12 }}
        />

        <FormInputField
          id={anchorId(ASSET_FIELD.model)}
          fieldName="model"
          label="Model"
          value={allValues?.model}
          error={!!getLocalAndLenderError({ fieldName: "model" })}
          helperText={getLocalAndLenderError({ fieldName: "model" })}
          disabled={searchVehicleLoader || isDisableEdit}
          onChange={handle.onChangeField}
          onBlur={handle.blurFn}
          inputProps={{ maxLength: 50 }}
          gridProps={{ md: 3, sm: 12, xs: 12 }}
        />

        <FormAutoCompleteField
          id={anchorId(ASSET_FIELD.condition)}
          fieldName="condition"
          label="Condition"
          value={allValues?.condition || ""}
          options={ConditionFieldOptions}
          error={!!getLocalAndLenderError({ fieldName: "condition" })}
          helperText={getLocalAndLenderError({ fieldName: "condition" })}
          disabled={searchVehicleLoader || typeOfSale === TypeOfSale.PrivateSale || isDisableEdit}
          onChange={handle.onChangeField}
          getOptionLabel={(option) => option || ""}
          gridProps={{ md: 2.9, sm: 12, xs: 12 }}
          variant="outlined"
          size="small"
        />

        <FormAutoCompleteField
          fieldName="ageOfAsset"
          label="Year of manufacture"
          value={allValues?.ageOfAsset?.toString() || ""}
          options={generateArrayOfYears()}
          error={!!getLocalAndLenderError({ fieldName: "ageOfAsset" })}
          helperText={getLocalAndLenderError({ fieldName: "ageOfAsset" })}
          disabled={searchVehicleLoader || isDisableEdit}
          onChange={handle.onChangeField}
          getOptionLabel={(option) => option || ""}
          gridProps={{ md: 3, sm: 12, xs: 12 }}
          variant="outlined"
          size="small"
        />
      </Grid>
    </Grid>
  );
};

export default AssetManualFields;
